import moment from 'moment-timezone';

class TrustedDeviceClass {

    active = true;
    created = null;
    id = null;
    name = null;
    platform = null;
    user_id = null;

    constructor() {
        return this;
    }

	create = (props = {}) => {
        this.active = props.active;
        this.created = props.created && moment.utc(props.created).local();
        this.id = props.id;
        this.name = props.name;
        this.platform = props.platform;
        this.user_id = props.user_id;
        return this;
	}
}

export default {
    Trusted: {
        create: props => new TrustedDeviceClass().create(props)
    }
}
